import { invoke } from '@tauri-apps/api/core';
import type { AppIcon } from '@avslack/shared';
import { apiBase, isDesktop, setDesktopToken } from './runtime';

/**
 * A desktop app es a kozos frontend kozotti hid.
 *
 * Minden fuggveny biztonsagos bongeszoben is: ott egyszeruen nem csinal semmit.
 * Igy a hivo helyeken nem kell `if (isDesktop())` szorast tartani.
 *
 * A korabbi `avslack://` deep-link belepes MEGSZUNT: az azert kellett, mert az
 * Entra tiltja a beagyazott webview-t, es a rendszer-bongeszobol kellett
 * visszaterni. Sajat jelszavas belepesnel a desktop egyszeruen elkuldi az
 * urlapot, es a valaszban megkapja a tokent - egy egesz alrendszerrel kevesebb.
 */

/** Olvasatlan-jelzes a talcaikonon es az ablak cimeben. */
export async function setUnreadBadge(count: number): Promise<void> {
  if (!isDesktop()) return;
  await invoke('set_unread', { count: Math.max(0, Math.trunc(count)) }).catch(() => undefined);
}

/** Az ablak elohozasa - pl. amikor ertesitesre kattintanak. */
export async function focusDesktopWindow(): Promise<void> {
  if (!isDesktop()) return;
  await invoke('focus_window').catch(() => undefined);
}

/**
 * A valasztott ikon atvitele az ABLAKRA es a TALCARA.
 *
 * ─── Miert bajtokat kuldunk, es nem fajlnevet? ──────────────────────────────
 *
 * Mert az asztali app a felulet SZERVERROL tolti (lasd `tauri.conf.json`
 * `frontendDist`), nem beagyazott fajlokbol. A Tauri sajat utfeloldasa a
 * telepitett binaris melletti eroforrasokat keresne, ahol ezek a kepek
 * nincsenek - es nem is lehetnek, kulonben minden uj paletta uj telepitot
 * igenyelne. Igy viszont a webszerverrol jon a kep, es egy uj paletta nulla
 * asztali munka.
 *
 * Ami NEM valtozik: a telepito es az `.exe` beegetett ikonja. A Start menu es
 * a kituzott parancsikon ezert marad az eredeti - az forditasi ideju eroforras.
 */
export async function setDesktopAppIcon(icon: AppIcon): Promise<void> {
  if (!isDesktop()) return;

  try {
    // `apiBase()` a fajlbol toltott feluletnek kell: ott a relativ ut sehova
    // nem mutat. Bongeszoben es tavolrol toltott asztali appnal ures.
    const response = await fetch(`${apiBase()}/icons/${icon}/icon-256.png`);
    if (!response.ok) return;

    const bytes = new Uint8Array(await response.arrayBuffer());
    // Sima tomb, nem `Uint8Array`: a Tauri IPC JSON-t visz at.
    await invoke('set_app_icon', { bytes: Array.from(bytes) });
  } catch {
    // Az ikon kenyelem, nem funkcio. Ha nem sikerul, marad a beepitett -
    // ez nem allithatja meg az alkalmazas inditasat.
  }
}

export async function getAutostart(): Promise<boolean> {
  if (!isDesktop()) return false;
  return invoke<boolean>('get_autostart').catch(() => false);
}

export async function setAutostart(enabled: boolean): Promise<void> {
  if (!isDesktop()) return;
  await invoke('set_autostart', { enabled }).catch(() => undefined);
}

/** Kijelentkezes desktopon: a token eldobasa eleg, suti nincs. */
export function clearDesktopSession(): void {
  setDesktopToken(null);
}
